import { Box, BoxProps, Text } from "@chakra-ui/react";

interface IProps extends BoxProps {}
const WarningText = ({ children, ...props }: IProps) => {
  return (
    <Box margin={{ base: "12px 0", md: "24px 0" }} {...props}>
      <Box padding="12px" borderRadius="6px" borderLeft="4px solid #fc501e" bg="#FAF3D4" fontSize="14px">
        <Box mb="6px">{children}</Box>

        <Text>
          If you don't receive the email, please reach out to our customer support at{" "}
          <Box fontWeight="600">
            <a href="mailto:support@bitmama.io">support@bitmama.io</a>
          </Box>
        </Text>
      </Box>
    </Box>
  );
};

export default WarningText;
